angular.module(ApplicationConfiguration.applicationModuleName).directive('cpfCnpjValidate', [function () {

  	var link = function ($scope, $element, $attrs, ctrl) {

  		var validate = function (viewValue) {  			
  			if (!viewValue)
  				ctrl.$setValidity('invalidCpfCnpj', true); // Válido pois não há o que validar
			else
  				ctrl.$setValidity('invalidCpfCnpj', validateCpfOrCnpj(viewValue));

  			return viewValue;
  		};

  		ctrl.$parsers.unshift(validate);
  		ctrl.$formatters.push(validate);
  	};

  	return {
  		require: 'ngModel',
  		link: link
  	};
  }
]);

var validateCpfOrCnpj = function (val) {
	val = val.replace(/[^0-9]+/g, "");

	if (val.length == 14)
		return validateCnpj(val);
	else if (val.length == 11)
		return validateCpf(val);
	else
		return false;
}

var validateCnpj = function (val) {
	val = val.replace(/[^0-9]+/g, "");

	if (val.length != 14)
		return false;

	var i;
	var result = true;

	var c = val.substr(0, 12);
	var dv = val.substr(12, 2);
	var d1 = 0;

	for (i = 0; i < 12; i++)
		d1 += c.charAt(11 - i) * (2 + (i % 8));

	if (d1 == 0)
		result = false;

	d1 = 11 - (d1 % 11);

	if (d1 > 9) d1 = 0;

	if (dv.charAt(0) != d1)
		result = false;

	d1 *= 2;
	for (i = 0; i < 12; i++) {
		d1 += c.charAt(11 - i) * (2 + ((i + 1) % 8));
	}

	d1 = 11 - (d1 % 11);
	if (d1 > 9) d1 = 0;

	if (dv.charAt(1) != d1)
		result = false;

	return result;
}

var validateCpf = function (val) {
	val = val.replace(/[^0-9]+/g, "");

	if (val.length != 11)
		return false;

	var i;
	var result = true;

	var c = val.substr(0, 9);
	var dv = val.substr(9, 2);
	var d1 = 0;

	for (i = 0; i < 9; i++) {
		d1 += c.charAt(i) * (10 - i);
	}

	if (d1 == 0)
		result = false;

	d1 = 11 - (d1 % 11);
	if (d1 > 9) d1 = 0;

	if (dv.charAt(0) != d1)
		result = false;

	d1 *= 2;
	for (i = 0; i < 9; i++) {
		d1 += c.charAt(i) * (11 - i);
	}

	d1 = 11 - (d1 % 11);
	if (d1 > 9) d1 = 0;

	if (dv.charAt(1) != d1)
		result = false;

	return result;

}